






















/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleModel, CurationInfoDTO, IssueModel } from "../../../Generated/ParticaAPI";
import ArticleTitle from "@/Ui-Components/Article/Common/ArticleTitle.vue";
import ArticleAbstract from "@/Ui-Components/Article/Common/ArticleAbstract.vue";
import ArticleSubheading from "@/Ui-Components/Article/Common/ArticleSubheading.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";

import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";
import { IMetadataArticle } from "../../../Models/ArticleModels/article";
import ArticleKeywords from "../Common/ArticleKeywords.vue";
import ArticleContributors from "../Common/ArticleContributors.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ArticlePageNumber from "@/Ui-Components/Article/Common/ArticlePageNumber.vue";
import ArticleSlug from "@/Ui-Components/Article/Common/ArticleSlug.vue";



@Component(
	{
		name: "ParticaArticleMetadata",
		components: {
			ArticleTitle,
			ArticleAbstract,
			ArticleSubheading,
			ArticleKeywords,
			ArticleContributors,
			ButtonList,
			ArticlePageNumber,
			ParticaRowContainer,
			ParticaColumnContainer,
			ParticaCard,
			ArticleSlug
		}
	})
export default class ParticaArticleMetadata extends Vue {
	@Prop() private article: IMetadataArticle; // your data
	@Prop() private buttons: ButtonConfig[];
	@Prop() private issue: IssueModel;
	private eventHandler(event: ParticaEvent) {
		event.item = this.article;
		this.$emit("partica-event", event);
	}
}
